import { render, staticRenderFns } from "./RangeRecommendations.vue?vue&type=template&id=4c282374&scoped=true"
import script from "./RangeRecommendations.vue?vue&type=script&lang=js"
export * from "./RangeRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c282374",
  null
  
)

export default component.exports